import { combineReducers } from 'redux';
import authenticationReducer from './authentication/reducer';
import infoUserLoggedReducer from './info-user-logged/reducer';

const rootReducer = combineReducers({
	authenticationReducer,
	infoUserLoggedReducer
});

export default rootReducer;